import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import trim from 'lodash/trim';
import { ManagedForm, Page, PasswordInput, TextInput } from 'modules/ui';
import { AuthHeader } from '../components';
import { Validator } from '../services';
import {
  clearResetPasswordStatus,
  getResetPasswordError,
  getResetPasswordSuccess,
  resetPassword,
} from '../redux';
import { useLocation, useNavigate } from 'react-router-dom';

const styles = {
  container: {
    flexBasis: 360,
  },
  changeButton: {
    width: '100%',
  },
  footer: {
    marginTop: 3,
  },
};

export default function ResetPasswordPage() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const resetPasswordError = useSelector(getResetPasswordError);
  const resetPasswordSuccess = useSelector(getResetPasswordSuccess);

  const urlParams = new URLSearchParams(location.search);
  const sub = urlParams.get('sub');

  useEffect(() => {
    if (resetPasswordSuccess) {
      return navigate('/success', {
        state: {
          title: 'Password changed',
          description: `Your password has been changed. Please login with your new password.`,
        },
      });
    }
  }, [resetPasswordSuccess, navigate]);

  useEffect(() => () => dispatch(clearResetPasswordStatus()), [dispatch]);

  const handleResetPassword = ({ code, password }) => {
    const trimmedCode = trim(code);
    return dispatch(resetPassword({ code: trimmedCode, password, sub }));
  };

  return (
    <Page
      className="pt-64"
      HeaderComponent={
        <AuthHeader
          showLogo={false}
          link="/login"
          linkLabel={`Return to ${window.location.hostname}`}
        />
      }
    >
      <ManagedForm
        title="Add new password"
        submitButtonLabel="Change"
        btnStyle={styles.changeButton}
        onSubmit={handleResetPassword}
        validate={Validator.resetPasswordData}
        footerStyle={styles.footer}
        error={resetPasswordError}
        style={styles.container}
        className="mt-48"
      >
        <TextInput
          required
          label="Code"
          name="code"
          placeholder="Enter code provided in email"
        />
        <PasswordInput
          label="New password"
          name="password"
          placeholder="Enter password"
        />
        <PasswordInput
          label="Confirm password"
          name="confirmPassword"
          placeholder="Enter password"
        />
      </ManagedForm>
    </Page>
  );
}
